const initialData = [
  {
    id: 1,
    title: "Tell us...",
    question: "Describe yourself...",
    category: "Personal",
    type: "Short Answer",
    answer: "I am...",
    avgTime: "3m",
    status: "complete", // ✅ Green tick
  },
  {
    id: 2,
    title: "Why this school?",
    question: "What made you apply?",
    category: "Motivation",
    type: "Short Answer",
    answer: "Because...",
    avgTime: "2m",
    status: "in-progress", // 🔵 Blue tick
  },
  {
    id: 3,
    title: "Experience",
    question: "Tell us about your project.",
    category: "Academic",
    type: "Long Answer",
    answer: "My project was...",
    avgTime: "5m",
    status: "complete", // ✅ Green tick
  },
];

export default initialData;
